import requests from '../../../../redux/reducer/requests';
import { useDispatch } from 'react-redux';

export default function useConverterCallback() {
  const dispatch = useDispatch();

  return {
    convertToCoins: () => dispatch(requests.thunks.convertToCoins()),
  };
}
